import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Table, Modal, Button, Form, Input, Icon } from 'semantic-ui-react'
import { searchDrivers, clearFoundDrivers } from '../../common/drivers/actions'

import './FindDriverModal.scss'

const initialState = {
  searchString: '',
  selectedDriver: null,
}

const { Header, Row, HeaderCell, Body, Cell } = Table

const getDriverActive = (result) => {
  if (result.state == 'ARCHIV')
    return <Icon name="remove user" color="red" size="large" />
  else if(result.state == 'HOME')
    return <Icon name="ban" color="red" size="large" />
  else if(result.state == 'IDLE')
    return <Icon name="home" color="red" size="large" />

  if (result.archived) {
    return <Icon name="remove user" color="red" size="large" />
  } else {
    return <Icon name="user" color="green" size="large" />
  }
}

const getBirthDate = (date) => {
  var m = moment('' + date);
  if (m.isValid()) {
    if (m.isAfter('1901-05-01')) { /* 2. května 1901 - Chiyo Miyako */
      return m.format('D.M.YYYY') + ' (' + moment().diff(m, 'years') + ')'
    } else {
      return '-'
    }
  } else {
    return '.'
  }
}

class FindDriverModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = Object.assign({}, initialState)
    this.selectDriver = (driver) => this.setState({ selectedDriver: driver })
    this.onSearchStringChange = this.onSearchStringChange.bind(this)
    this.onClose = this.onClose.bind(this)
  }
  componentWillUnmount() {
    this.setState(initialState)
  }
  onSearchStringChange(e, { value }) {
    const { searchDrivers } = this.props
    this.setState({ searchString: value })
    searchDrivers({ filters: { nameForSearch: { like: value } }, sort: 'lastNameSort' })
  }
  onClose() {
    const { onClose } = this.props
    this.setState(initialState)
    onClose()
  }
  render() {
    const {
      open,
      onClose,
      onConfirm,
      confirmMessage,
      headerMessage,
      drivers,
      ignoredDrivers,
     } = this.props
    const { searchString, selectedDriver } = this.state
    const foundDrivers = drivers.size > 0 ? drivers.filter(d => ignoredDrivers.indexOf(d._id) === -1) : []
    return (
      <Modal open={open} onClose={onClose} className="find-driver-modal" size="small">
        <Modal.Header>{headerMessage}</Modal.Header>
        <Modal.Content>
          <Form size="huge">
            <Input
              fluid
              icon="search"
              type="text"
              placeholder="Zadejte jméno řidiče..."
              onChange={this.onSearchStringChange}
              value={searchString}
            />
          </Form>

          {foundDrivers.size > 0 &&
            <Table>
              <Header>
                <Row>
                  <HeaderCell className="cell-with-icon" />
                  <HeaderCell>
                    Příjmení
                  </HeaderCell>
                  <HeaderCell>
                    Jméno
                  </HeaderCell>
                  <HeaderCell>
                    Datum narození
                  </HeaderCell>
                  <HeaderCell>
                    Společnost
                  </HeaderCell>
                </Row>
              </Header>
            </Table>
          }
          {foundDrivers.size > 0 &&
            <div className="search-results">
              <Table>
                <Body>
                  {foundDrivers.map(d => (
                    <Row key={d._id} onClick={() => this.selectDriver(d)} className={selectedDriver && d._id === selectedDriver._id ? 'selected' : ''}>
                      <Cell className="cell-with-icon">{getDriverActive(d)}</Cell>
                      <Cell>
                        {d.lastName}
                      </Cell>
                      <Cell>
                        {d.firstName}
                      </Cell>
                      <Cell>
                        {getBirthDate(d.birthdate)}
                      </Cell>
                      <Cell>
                        {d.companyName}
                      </Cell>
                    </Row>
                  ))}
                </Body>
              </Table>
            </div>
          }
        </Modal.Content>
        <Modal.Actions>
          {!!selectedDriver &&
            <Button
              size="huge"
              color="green"
              onClick={() => {
                onConfirm(selectedDriver)
                this.onClose()
              }}
            >
              {confirmMessage}
            </Button>
          }
          <Button size="large" basic onClick={this.onClose}>Zrušit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

FindDriverModal.defaultProps = {
  open: false,
  ignoredDrivers: [],
}

FindDriverModal.propTypes = {
  open: React.PropTypes.bool,
  onClose: React.PropTypes.func.isRequired,
  onConfirm: React.PropTypes.func.isRequired,
  confirmMessage: React.PropTypes.string.isRequired,
  headerMessage: React.PropTypes.string.isRequired,
  searchDrivers: React.PropTypes.func.isRequired,
  drivers: React.PropTypes.object.isRequired,
  ignoredDrivers: React.PropTypes.object,
}

export default connect(state => ({
  drivers: state.drivers.found,
}), { clearFoundDrivers, searchDrivers })(FindDriverModal)



// WEBPACK FOOTER //
// ./src/browser/components/FindDriverModal.js